import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

// Page transition wrapper
const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0 },
  exit: { opacity: 0, y: -20 },
};

// Animated section component
function AnimatedSection({ children, className, delay = 0 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-100px' });

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y: 40 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.6, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.div>
  );
}

function KineticTypography() {
  return (
    <motion.div
      className="digital-interactive-page kinetic-standalone-page"
      style={{ padding: 'clamp(2rem, 5vw, 4rem)', maxWidth: '900px', margin: '0 auto' }}
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.5 }}
    >
      <section className="motion-design-section" style={{ textAlign: 'center' }}>
        <AnimatedSection className="project-header playful">
          <h3 style={{ fontSize: '1.75rem', marginBottom: '0.75rem' }}>Kinetic Typography</h3>
          <p className="project-tagline" style={{ fontSize: '0.95rem' }}>
            Bringing Music to Life Through <em>Movement</em>
          </p>
          <p style={{ maxWidth: '600px', margin: '1rem auto 0', fontSize: '0.95rem', opacity: 0.7 }}>
            Animated lyrics synchronized with "Deja Vu" by Olivia Rodrigo,
            bringing the song's emotional journey to life through movement and typography.
          </p>
        </AnimatedSection>

        <AnimatedSection className="motion-content" delay={0.1}>
          <div className="kinetic-feature">
            <div className="kinetic-video-container">
              <video
                controls
                poster="/images/digital/DejaVu-Still1.png"
                className="kinetic-video"
              >
                <source src="/images/digital/deja-vu-kinetic-typography.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>

            <div className="kinetic-stills">
              <img src="/images/digital/DejaVu-Still1.png" alt="Deja Vu typography frame" />
              <img src="/images/digital/DejaVu-Still2.png" alt="Deja Vu typography frame" />
              <img src="/images/digital/DejaVu-Still3.png" alt="Deja Vu typography frame" />
              <img src="/images/digital/DejaVu-Still4.png" alt="Deja Vu typography frame" />
              <img src="/images/digital/DejaVu-Still5.png" alt="Deja Vu typography frame" />
              <img src="/images/digital/DejaVu-Still6.png" alt="Deja Vu typography frame" />
            </div>

            <div className="skills-tags" style={{ marginTop: '3.5rem', justifyContent: 'center' }}>
              <span className="skill-tag no-arrow">After Effects</span>
              <span className="skill-tag no-arrow">Illustrator</span>
            </div>

            <p style={{ marginTop: '0.75rem', fontSize: '0.85rem', opacity: 0.6 }}>
              By Sami de Nicola | <a href="mailto:sami@samidenicola.com" style={{ color: 'inherit' }}>sami@samidenicola.com</a>
            </p>
          </div>
        </AnimatedSection>
      </section>
    </motion.div>
  );
}

export default KineticTypography;
